import { Component, Input, OnInit } from '@angular/core';
import { TYPE_SECTIONS } from 'app/core/models/constans.model';
import { Item, Menu, SectionMenu } from '../../models/menu.model';
import { MenuService } from '../../services/menu.service';

@Component({
    selector: 'app-item-drinks',
    templateUrl: './item-drinks.component.html',
    styleUrls: ['./item-drinks.component.scss'],
    standalone: false
})
export class ItemDrinksComponent implements OnInit {
  /**
   * Informacion del menu seleccionado
   */
  @Input() menu: Menu = {} as Menu;
  /**
   * Listado de productos
   */
  @Input() section: SectionMenu = {} as SectionMenu;
  /**
   * Indica el idioma seleccionado
   */
  language: string | undefined;
  /**
   * Tipos de secciones
   */
  readonly TYPE_SECTIONS = TYPE_SECTIONS;
  constructor(
    private menuService: MenuService,
  ) { }

  ngOnInit(): void {
    this.menuService.language$.subscribe((lang: string) => {
      this.language = lang;
    });
  }
  clickName(item: Item): void {
    this.menuService.sendAnalyticsInfo(item, this.menu.departament, 'product_click');
  }
}
